// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.client.moodys.enums.AdproductsMoodysReportType

export enum AdproductsMoodysReportType {
  MARKET = 'MARKET',
  SUBMARKET = 'SUBMARKET',
}

export const AdproductsMoodysReportType_values = [
  AdproductsMoodysReportType.MARKET,
  AdproductsMoodysReportType.SUBMARKET,
] as const;
